// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"34877978","453":"f8db0ecb","455":"4042f095"}[chunkId] + ".chunk.js";
};